<h2>Sender ID Search</h2>
<div class="search__container">
  <div class="search__description">
    <p>
      The Sender ID search provides information on the Organisation that owns and uses specific Sender IDs.
    </p>
    <p>
      If a Sender ID is not found here then it has not been approved by ComReg for use by any organisation at this time.
    </p>
  </div>
  <div class="search__form-group">
    <div class="search__input-container">
      <form [formGroup]="form" class="search__form">
        <mat-form-field class="search__input">
          <mat-label>Search</mat-label>
          <input matInput formControlName="search" id="search" type="text" placeholder="Type at least 3 characters" />
          <mat-error comFormMessageName="search">Please enter valid Sender ID</mat-error>
        </mat-form-field>
      </form>
      <div class="search__spinner">
        <div *comSpinner="isFetching; color: 'primary'; diameter: 25"></div>
      </div>
    </div>
    <button mat-raised-button class="button--secondary" [routerLink]="'/'">Back</button>
  </div>

  <table *ngIf="isFetched" #senderIdSort="matSort" mat-table matSort [dataSource]="senderIdDataSource">
    <ng-container matColumnDef="senderIdText">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Sender ID</th>
      <td mat-cell *matCellDef="let element" [siExactMatch]="element.isExactMatch">
        {{ element.senderIdText }}
      </td>
    </ng-container>

    <ng-container matColumnDef="organisationName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Organisation Name</th>
      <td mat-cell *matCellDef="let element" [siExactMatch]="element.isExactMatch">
        {{ element.organisationName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="statusDesc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element" [siExactMatch]="element.isExactMatch">
        {{ element.statusDesc }}
      </td>
    </ng-container>

    <tr *matNoDataRow>
      <td colspan="3">Sender IDs list is empty</td>
    </tr>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>

  <mat-paginator *ngIf="isFetched" #senderIdPaginator [pageSizeOptions]="TableConstants.pageSize" aria-label="Page size"></mat-paginator>
</div>
